import React from 'react';
import { formatLabel, formatTemperature } from 'utils/helpers';
import { hasContent, renderPrecautions, renderArray } from './utils';

const StorageSection = ({ 
  chemicalDetails, 
  isGas, 
  isSolid, 
  isLiquid,
  isAboveTemperaturePoint
}) => {
  return (
    <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100 transition-all duration-300 hover:shadow-xl">
      <h2 className="text-2xl font-bold mb-6">
        <i className="fas fa-warehouse mr-2"></i>Storage Information
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* Boiling Point - Don't show for gases */}
        {!isGas && formatTemperature(chemicalDetails.storage?.boiling_point) !== null && (
          <div className={`rounded-lg p-6 shadow border bg-white`}>
            <div className="font-bold text-lg mb-2">{formatLabel('Boiling Point')}</div>
            <div className="text-2xl font-bold mb-2">{formatTemperature(chemicalDetails.storage.boiling_point)}</div>
            {isAboveTemperaturePoint(chemicalDetails.storage.boiling_point) && (
              <div className="p-3 bg-red-100 border border-red-400 text-red-700 rounded-lg mt-2">
                <i className="fas fa-exclamation-triangle mr-2"></i>
                <strong>Alert:</strong> The current temperature of your selected location exceeds the boiling point of this chemical. It may cause the chemical to vaporise. Please store the chemical in a cooler storage container.
              </div>
            )}
          </div>
        )}
        {/* Flash Point */}
        {formatTemperature(chemicalDetails.storage?.flash_point) !== null && (
          <div className={`rounded-lg p-6 shadow border bg-white`}>
            <div className="font-bold text-lg mb-2">{formatLabel('Flash Point')}</div>
            <div className="text-2xl font-bold mb-2">{formatTemperature(chemicalDetails.storage.flash_point)}</div>
            {isAboveTemperaturePoint(chemicalDetails.storage.flash_point) && (
              <div className="p-3 bg-red-100 border border-red-400 text-red-700 rounded-lg mt-2">
                <i className="fas fa-exclamation-triangle mr-2"></i>
                <strong>Alert:</strong> The current temperature of your selected location exceeds the flash point of this chemical. It may catch fire at any point. Please store in a cooler storage container.
              </div>
            )}
          </div>
        )}
        {/* Melting Point - Don't show for solids OR gases */}
        {isSolid && !isGas && !isLiquid && formatTemperature(chemicalDetails.storage?.melting_point) !== null && (
          <div className={`rounded-lg p-6 shadow border bg-white`}>
            <div className="font-bold text-lg mb-2">{formatLabel('Melting Point')}</div>
            <div className="text-2xl font-bold mb-2">{formatTemperature(chemicalDetails.storage.melting_point)}</div>
            {isAboveTemperaturePoint(chemicalDetails.storage.melting_point) && (
              <div className="p-3 bg-red-100 border border-red-400 text-red-700 rounded-lg mt-2">
                <i className="fas fa-exclamation-triangle mr-2"></i>
                <strong>Alert:</strong> The current temperature of your selected location exceeds the melting point of this chemical. It may melt or form vapours at any point. Please store in a cooler storage container.
              </div>
            )}
          </div>
        )}
        {/* Precautions */}
        {hasContent(chemicalDetails.storage?.precautions) && (
          <div className="rounded-lg p-6 shadow border bg-yellow-50 border-yellow-500">
            <div className="font-bold text-lg mb-2">{formatLabel('Precautions')}</div>
            <div>{renderPrecautions(chemicalDetails.storage.precautions)}</div>
          </div>
        )}
        {/* Sources of Ignition Precautions */}
        {hasContent(chemicalDetails.storage?.source_of_ignition_precautions) && (
          <div className="rounded-lg p-6 shadow border bg-yellow-50">
            <div className="font-bold text-lg mb-2">{formatLabel('Sources of Ignition Precautions')}</div>
            <div>{renderArray(chemicalDetails.storage.source_of_ignition_precautions)}</div>
          </div>
        )}
        {/* Storage Conditions */}
        {hasContent(chemicalDetails.storage?.storage_conditions) && (
          <div className="rounded-lg p-6 shadow border bg-gray-50">
            <div className="font-bold text-lg mb-2">{formatLabel('Storage Conditions')}</div>
            <div>{renderPrecautions(chemicalDetails.storage.storage_conditions)}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default StorageSection;
